const componentsDataTableEn = {
  hrPrimary: "Primary",
  vendorMarketplace: {
    title: "Title",
    customer: "Customer",
    acceptedAt: "Agreement date",
    deliveryDate: "Delivery date",
    sentAt: "Request date",
    canceledAt: "Cancellation date",
    total: "Total",
    orderNumber: "Order No.",
    orderedByPerson: "Ordered by",
  },
  productPermissions: {
    productPermissionName: "Product permission name",
    totalAccessibleProducts: "Total accessible products",
    itForce: "IT Force",
    hrForce: "HR Force",
    gaForce: "GA Force",
    liForce: "LI Force",
    marketplace: "Marketplace",
    settings: "Settings",
    referencedRoles: "Referenced roles",
  },
  productPermissionForces: {
    code: "", // 空ヘッダー
    scopes: "Product",
  },
  peopleGroups: {
    name: "Name",
    totalPeople: "Total people",
    membershipEmployee: "Membership Employee",
    membershipBoardMember: "Membership Board member",
    membershipContractor: "Membership Contractor",
    membershipCollaborator: "Membership Collaborator",
    individuallyIncluded: "Individually included",
    individuallyExcluded: "Individually excluded",
    referencedRoles: "Referenced roles",
  },
  roles: {
    roleName: "Role name",
    totalPeople: "Total people",
    peopleGroups: "People group",
    productPermissions: "Product permission",
  },
  shadowIt: {
    app: "App",
    software: "Software",
    category: "Category",
    websiteUrl: "Link",
    countUniqueUser: "Unique User Count",
    count7DaysDetected: "7 Days Access Count",
    count30DaysDetected: "30 Days Access Count",
    detectionTool: "Detection Tool",
    url: "Accessed URL",
    visitedAt: "Detected At",
    user: "Recently Accessed Person",
    usedLoginId: "Used Login ID",
  },
  externalHrSaas: {
    syncType: "Sync Type",
    lastSyncedAt: "Last synced date",
    syncResult: "Sync result",
  },
  operationArchives: {
    status: "Status",
    finishedAt: "Finished At",
    createdAt: "Started At",
    packageName: "Operation Package",
    patternName: "Pattern",
    targetResource: "Target",
    anchorDate: "Anchor Date",
    operator: "Operator",
    completed: "Completed",
    aborted: "Aborted",
  },
  externalItSaas: {
    appIntegration: "Connected Service",
    syncType: "Sync Type",
    lastSyncedAt: "Last synced date",
    syncResult: "Sync result",
  },
  itOperationCore: {
    requestedFor: "requested for",
    progress: "progress",
  },
  organizationPlan: {
    effectiveDate: "Effective date",
  },
  license: {
    name: "License",
    assignedTotal: "Assigned/Total",
    enabledTotal: "Enabled/Total",
    expirationDate: "License expiration date",
    renewalDate: "Renewal date",
    ownerOrganization: "License owner organization unit",
    device: "License assigned device",
    assignedUser: "Device assignment",
    placement: "Device placement",
    responsiblePerson: "Responsible person",
    notes: "Notes",
    vendorName: "Vendor name",
    productVersion: "Product version",
  },
  licenseService: {
    externalId: "External ID",
  },
  healthInsuranceAssociations: {
    associationType: "Health insurance society type",
    associationName: "Health insurance society name",
  },
  placeSocialInsurances: {
    businessEstablishment: "Business Establishment",
    address: "Address",
    representative: "Representative",
  },
  educationsAndQualifications: {
    certificationId: "Certification ID",
    certificationName: "Certification Name",
    certificationParty: "Certification Party",
    effectiveDate: "Effective Date",
    expirationDate: "Expiration Date",
    renewalDate: "Renewal Date",
    certificationHolder: "Certification Holder",
  },
  organization: {
    path: "Path",
    manager: "Manager",
    size: "Size",
    hierarchyLevel: "Hierarchy Level",
    orderInHierarchy: "Order in Hierarchy",
    parentName: "Parent Name",
  },
};

export default componentsDataTableEn;
